import React from 'react';
import styles from './index.module.less';

export interface JoinUsProps {
    /** X（Twitter）主页链接 */
    xUrl: string;
    /** Discord 邀请链接 */
    discordUrl: string;
    /** 是否固定悬浮在右下角，默认 true。传 false 则作为普通行内组件渲染 */
    fixed?: boolean;
    className?: string;
}

const XIcon: React.FC = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

const DiscordIcon: React.FC = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d="M20.317 4.369A19.791 19.791 0 0 0 15.885 3c-.211.375-.457.88-.626 1.28a18.27 18.27 0 0 0-5.518 0A12.87 12.87 0 0 0 9.115 3 19.736 19.736 0 0 0 4.68 4.372C1.593 8.947.788 13.409 1.19 17.808a19.9 19.9 0 0 0 5.993 3.03c.484-.657.914-1.354 1.283-2.087a12.7 12.7 0 0 1-2.02-.968c.17-.123.336-.252.497-.384a14.128 14.128 0 0 0 12.11 0c.163.14.328.269.497.384-.641.379-1.319.702-2.02.969.37.732.8 1.43 1.283 2.086a19.83 19.83 0 0 0 6.001-3.03c.472-5.096-.803-9.517-3.497-13.44ZM8.68 15.098c-1.161 0-2.115-1.062-2.115-2.368 0-1.305.936-2.368 2.115-2.368 1.19 0 2.136 1.073 2.116 2.368 0 1.306-.936 2.368-2.116 2.368Zm6.64 0c-1.16 0-2.114-1.062-2.114-2.368 0-1.305.936-2.368 2.114-2.368 1.19 0 2.137 1.073 2.117 2.368 0 1.306-.927 2.368-2.117 2.368Z" />
    </svg>
);

const JoinUs: React.FC<JoinUsProps> = ({ xUrl, discordUrl, fixed = true, className }) => {
    return (
        <div className={`${styles.joinUs} ${fixed ? styles.fixed : ''} ${className ?? ''}`}>
            <a className={styles.item} href={xUrl} target="_blank" rel="noopener noreferrer">
                <span className={styles.icon}>
                    <XIcon />
                </span>
                <span className={styles.text}>Follow us on X</span>
            </a>

            <span className={styles.divider} />

            <a className={styles.item} href={discordUrl} target="_blank" rel="noopener noreferrer">
                <span className={styles.icon}>
                    <DiscordIcon />
                </span>
                <span className={styles.text}>Join our Discord</span>
            </a>
        </div>
    );
};

export default JoinUs;
